import { withForm } from '@/components/react/form/hooks/form';
import {
  ERROR_MESSAGES,
  FORM_HELP_OPTIONS,
  FORM_HELP_SUPPORT_OPTIONS,
  INPUT_LABELS,
} from '@/components/react/form/translations';
import type { AstroLocale } from '@/schemas/components/shared/i18n';
import { contactFormOptions } from './formOptions';

export const LongFormFields = withForm({
  ...contactFormOptions,
  props: {
    language: 'en' as AstroLocale,
  },
  render: ({ form, language }) => {
    return (
      <>
        <div className="flex flex-col gap-x-8 lg:flex-row">
          <form.AppField
            name="howCanWeHelp"
            validators={{
              onChange: ({ value }) => {
                if (!value) return ERROR_MESSAGES.empty[language];
              },
            }}
          >
            {(field) => (
              <field.SelectDropdown
                items={FORM_HELP_OPTIONS}
                placeholder={INPUT_LABELS.howCanWeHelp[language]}
                language={language}
              />
            )}
          </form.AppField>
        </div>
        <form.Subscribe selector={({ values }) => values.howCanWeHelp}>
          {(howCanWeHelpSelection) => {
            if (howCanWeHelpSelection === 'other_radio') {
              return (
                <div className="flex flex-col lg:flex-row lg:gap-8">
                  <form.AppField
                    name="supportDummy"
                    validators={{
                      onChange: ({ value }) => {
                        if (!value) return ERROR_MESSAGES.empty[language];
                      },
                    }}
                  >
                    {(field) => (
                      <field.SelectDropdown
                        items={FORM_HELP_SUPPORT_OPTIONS}
                        placeholder={INPUT_LABELS.support[language]}
                        language={language}
                      />
                    )}
                  </form.AppField>
                </div>
              );
            }
          }}
        </form.Subscribe>
        <div>
          <form.AppField
            name="How_Did_You_Hear_About_Us"
            validators={{
              onChange: ({ value }) => {
                if (!value) return ERROR_MESSAGES.empty[language];
              },
            }}
          >
            {(field) => (
              <field.TextInput
                label={INPUT_LABELS.howDidYouHearAboutUs[language]}
              />
            )}
          </form.AppField>
        </div>
      </>
    );
  },
});
